import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconPhone = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconPhone",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M798-120q-125 0-247-54T329-329 175-551t-55-247q0-18 12-30t30-12h162q14 0 25 10t13 22l26 140q2 16-1 27t-11 19l-97 98q20 37 48 72t60 66q31 31 65 58t72 48l94-94q9-9 24-13t28-3l138 28q14 4 23 15t9 23v162q0 18-12 30t-30 12"
  })
}));
IconPhone.displayName = 'IconPhone';